import queryString from "query-string";

const checkIfFilter = () => {
    return {};
};

const resetPaginationFields = { current: 1, pageSize: 20, total: undefined };

const configureSort = (sortedBy, direction, key) => {
    const sortKey = sortedBy;
    const sortOrder = direction == "DESC" ? "descend" : "ascend";
    return {
        doctrineKey: key,
        sorter: true,
        sortOrder: sortKey == key && sortOrder,
    };
};

const configureField = (key, filters, resize, hidden, allowSort, allowResize, allowHide, width) => {
    const sortKey = filters.sort;
    const sortOrder = filters.direction == "DESC" ? "descend" : "ascend";

    const resizeProps = allowResize ? { width: resize[key] ? resize[key] : width } : {};

    return {
        key: key,
        doctrineKey: key,

        sorter: allowSort,
        sortOrder: sortKey == key && sortOrder,

        allowResize: allowResize,
        ...resizeProps,

        allowHide: allowHide,
        visible: hidden[key] ? hidden[key] == 0 : true,
    };
};

/**
 *
 */
const onTableChangeUpdateUrl = (history, pagination, filters, sorter) => {
    let knpSort = {};
    if (sorter.column !== undefined) {
        knpSort = { sort: sorter.column.doctrineKey, direction: sorter.order === "descend" ? "DESC" : "ASC" };
    }

    const { sort, direction, ...data } = decodeQueryFromURL(history);

    const mergeFilters = { ...data, ...pagination, ...filters, ...knpSort };

    encodeQueryToURL(history, mergeFilters);
};

const onFilterChangeUpdateUrl = (history, form) => {
    const parameters = decodeQueryFromURL(history);

    const mergeFilters = { ...parameters, ...form, ...resetPaginationFields };

    encodeQueryToURL(history, mergeFilters);
};

const encodeQueryToURL = (history, data) => {
    const search = queryString.stringify(data, { arrayFormat: "bracket" });

    //history.push vs replace
    history.replace({
        pathname: history.location.pathname,
        search: search,
    });
};

const decodeQueryFromURL = (history, defaultValues = {}) => {
    const data = history.location.search;
    return { ...defaultValues, ...queryString.parse(data, { arrayFormat: "bracket" }) };
};

export {
    configureSort,
    configureField,
    encodeQueryToURL,
    decodeQueryFromURL,
    onTableChangeUpdateUrl,
    onFilterChangeUpdateUrl,
};
